import { useState } from 'react';

interface ShareBarProps {
  title: string;
}

const shareTargets = [
  { key: 'wechat', label: '微信', icon: 'ri-wechat-line', tip: '请打开微信，扫描分享二维码或转发给好友' },
  { key: 'weibo', label: '微博', icon: 'ri-weibo-line', tip: '已为你准备好分享内容，前往微博即可发布' },
  { key: 'link', label: '复制链接', icon: 'ri-link', tip: '页面链接已复制，可粘贴分享给好友' },
  { key: 'star', label: '收藏', icon: 'ri-star-line', tip: '收藏功能为演示效果，暂未开放账号体系' },
];

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState('');

  const handleShare = (tip: string) => {
    setToast(tip);
    window.setTimeout(() => setToast(''), 2400);
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="text-xs text-secondary-500">分享：</span>
      {shareTargets.map((s) => (
        <button
          key={s.key}
          type="button"
          onClick={() => handleShare(s.tip)}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600"
        >
          <i className={s.icon}></i>
          {s.label}
        </button>
      ))}

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-[60] -translate-x-1/2 rounded-md bg-secondary-950 px-5 py-3 text-sm text-background-50">
          <span className="flex items-center gap-2">
            <i className="ri-information-line text-accent-400"></i>
            {toast}
          </span>
        </div>
      )}
      <span className="sr-only">{title}</span>
    </div>
  );
}